import React from 'react';
import { Drawer, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Register from './Register';

const RegisterDrawer = ({ open, onClose }) => (
  <Drawer 
    anchor="right" 
    open={open} 
    onClose={onClose}
    PaperProps={{
      sx: {
        width: { xs: '65vw', sm: '55vw', md: 400 }, // ✅ 65% on mobile
        maxWidth: '100vw',
        boxShadow: 24
      }
    }}
    ModalProps={{
      keepMounted: true
    }}
    SwipeAreaProps={{
      sx: { width: 20 }
    }}
    disableSwipeToOpen={false}
  >
    {/* ✅ Floating Close Button */}
    <IconButton
      onClick={onClose}
      sx={{
        position: 'fixed',
        top: { xs: 8, sm: 12 },
        right: { xs: 8, sm: 12 },
        zIndex: 1400,
        bgcolor: 'error.main',
        color: 'white',
        width: { xs: 36, sm: 40 },
        height: { xs: 36, sm: 40 },
        boxShadow: 3,
        '&:hover': {
          bgcolor: 'error.dark',
          transform: 'scale(1.1)'
        },
        transition: 'all 0.2s'
      }}
    >
      <CloseIcon sx={{ fontSize: { xs: 20, sm: 24 } }} />
    </IconButton>

    {/* ✅ Content with proper padding for header offset */}
    <Box sx={{ 
      width: '100%', 
      padding: { xs: 2, sm: 3 },
      paddingTop: { xs: '86px', sm: '106px', md: '126px' }, // Header offset
      overflowY: 'auto',
      height: '100vh'
    }}>
      <Register />
    </Box>
  </Drawer>
);

export default RegisterDrawer;
